import { Vue, Component, Prop } from "vue-property-decorator";
import api from "@/api/index"; //ABP API接口
import { checkRole, checkPermission } from "@/utils/permission";

export interface IElementTable {
  elementLoadingText: string;
  listLoading: boolean;

  page: number;
  pagesize: number;
  totalCount: number;
  sorting: string | undefined;

  pageSizes: number[];
}

export interface PagedResultDto {
  items: any[];
  totalCount: number;
}

export const DefaultElementTable: IElementTable = {
  elementLoadingText: "数据更新中...",
  listLoading: true,

  page: 1,
  pagesize: 10,
  totalCount: 0,
  sorting: undefined, // 'id descending',

  pageSizes: [10, 20, 50, 100]
};

@Component
export class ElementTableView extends Vue {

  private checkPermission = checkPermission;
  private checkRole = checkRole;

  abpApi: any = null;

  tableItems: any[] = [];

  queryForm: any = {
    keyword: "",
    from: undefined,
    to: undefined,
    isActive: undefined
  }

  public table = DefaultElementTable;

  get skipCount() {
    return (this.table.page - 1) * this.table.pagesize;
  }

  async fetchData() {
    console.warn("%cu must reWrite this method", "color:#0048BA;");
    if (!this.abpApi)
      console.error("%c必须先设置使用哪个API", "color:#0048BA;");
    else {
      this.table.listLoading = true;
      await api.cmsCategory
        .getAll({
          keyword: this.queryForm.keyword,
          isActive: this.queryForm.isActive,
          sorting: this.table.sorting,
          from: this.queryForm.from,
          to: this.queryForm.to,
          skipCount: this.skipCount,
          maxResultCount: this.table.pagesize
        })
        .then(res => {
          console.log(res);
          this.table.listLoading = false;
          this.tableItems = res.items!;
          this.table.totalCount = res.totalCount!;
        });
    }
  }

  // 更新当前页
  async current_change(e: number) {
    console.warn("%cu must reWrite this method", 'color:#0048BA;');
    this.table.page = e;
    await this.fetchData();

  }

  // Table排序
  async sort(e: any) {
    console.warn("%cu must reWrite this method", 'color:#0048BA;');
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    console.warn("%cu must reWrite this method", 'color:#0048BA;');
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    console.warn('%cu must reWrite this method', 'color:#0048BA;')
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    console.warn('%cu must reWrite this method', 'color:#0048BA;')
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    }
    await this.fetchData();
  }

  handleCreate(): void {
    console.warn('%cu must reWrite this method', 'color:#0048BA;')
  }

  handleEdit(index: number, row: any): void {
    console.warn("%cu must reWrite this method", 'color:#0048BA;');
  }

  async handleDelete(index: number, row: any): Promise<void> {
    console.warn("%cu must reWrite this method", 'color:#0048BA;');
  }
}

export default {
  DefaultElementTable,
  ElementTableView
}